/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./advertisers-dialog.vue?vue&type=template&id=5b45f4e6&scoped=true&"
import script from "./advertisers-dialog.vue?vue&type=script&lang=ts&"
export * from "./advertisers-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./advertisers-dialog.vue?vue&type=style&index=0&id=5b45f4e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b45f4e6",
  null
  
)

export default component.exports